import React from 'react';
import { site_base } from '../Site';
import {Col, Container, Row } from 'reactstrap';
import { T } from '../traks';

function Contact(props) {
	let extra_lawheader = null;
	let extra_header = null;
	let registry_txt = null;
	let content_section = null;
	let contact_h1 = <h1 className="pb-4"><T>Contact us</T></h1>;
	const vat_no = "DK 38962256";

	return (
		<Container>
			<Row className="ad_game_card bg-white pt-3 pb-5">
				<Col className="pt-3">
					{contact_h1}
					{extra_lawheader}
					<div className="pb-3">
						Aktiedysten ApS<br/>
						Flakhaven 1, 1.<br/>
						DK-5000 Odense C<br/>
						<T>Denmark</T><br/>
					</div>
					{extra_header}
					<div className="pb-4">
						Email: info@{site_base}<br/>
					</div>
					<h4><T>Managing director</T></h4>
					<div className="pb-4">
						Mads Martin Jørgensen
					</div>
					{registry_txt}
					<h4><T>VAT information</T></h4>
					<div className="pb-4">
						<T>VAT ID</T>: {vat_no}
					</div>
					{content_section}
				</Col>
			</Row>
		</Container>
	);
}
export default Contact;



// WEBPACK FOOTER //
// ./src/p/Contact.js